import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";
import { data } from "react-router-dom";

export const loginToMoodle = async (data: any) => {
  try {
    const formData = Object.keys(data)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      )
      .join("&");

    const response = await moodleInstanceApi.post(
      "/login/token.php",
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    if (response.data.error) {
      throw new Error(response.data.error);
    }

    if (!response.data?.token) {
      throw new Error("Không nhận được token đăng nhập từ Moodle API.");
    }

    return response?.data;
  } catch (error) {
    throw handleApiError(error as AxiosError);
  }
};


export const getSiteInfo = async () => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_webservice_get_site_info",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getUserRole = async (id: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_userroles_get_system_roles",
          userid: id,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getUserInfo = async (studentid: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_user_get_users_by_field",
          field: "id",
          "values[0]": studentid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};



export const logOut = async () => {
  sessionStorage.removeItem("wstoken");
  return Promise.resolve({ message: "Đăng xuất thành công" });
};

export const checkForcePassChage = async () => {
  try {
    const response = await moodleInstanceApi.get (
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_changepassword_check",
        },
      }
    );
    return response?.data
  }catch (error) {
    return handleApiError (error as AxiosError);
  }
}

export const changePassword = async (formData: any) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      formData,
      {
        params: {
          wsfunction: "local_changepassword_update",
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};


export const updateUser = async (formData: any) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      formData,
      {
        params: {
          wsfunction: "core_user_update_users",
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return { errorcode: true, message: 'Đã có lỗi xảy ra' };
  }
}

export const updateUserPicture = async (formData: any) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      formData,
      {
        params: {
          wsfunction: "core_user_update_picture ",
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return { errorcode: true, message: 'Đã có lỗi xảy ra' };
  }
}


